import { render, staticRenderFns } from "./MenuAdmin.vue?vue&type=template&id=f89f3da0&scoped=true&"
import script from "./MenuAdmin.vue?vue&type=script&lang=js&"
export * from "./MenuAdmin.vue?vue&type=script&lang=js&"
import style0 from "./MenuAdmin.vue?vue&type=style&index=0&id=f89f3da0&scoped=true&lang=css&"
import style1 from "./MenuAdmin.vue?vue&type=style&index=1&id=f89f3da0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89f3da0",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VList,VListItem,VListItemAction,VListItemContent})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f89f3da0')) {
      api.createRecord('f89f3da0', component.options)
    } else {
      api.reload('f89f3da0', component.options)
    }
    module.hot.accept("./MenuAdmin.vue?vue&type=template&id=f89f3da0&scoped=true&", function () {
      api.rerender('f89f3da0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MenuAdmin.vue"
export default component.exports